import { createContext, useMemo, useState } from "react";
import PopUpContextValues from "../models/contextModels/popupContextValues.model";
import CustomPopUp from "../../components/global/CustomPopup";

interface PopUpContextProviderProps {
  readonly children: React.ReactNode;
}

const values: PopUpContextValues = {
  visible: false,
  setVisible: (visible) => null,
  setPopUp: (popUp) => null,
  setPopUpTitle: (title) => null,
  onlineOrder: false,
  setOnlineOrder: (onlineOrder) => null,
  hideClose: false,
  setHideClose: (value) => null
};

export const PopUpContext = createContext(values);

function PopUpContextProvider({ children }: PopUpContextProviderProps) {
  const [visible, setVisible] = useState(false);
  const [popUp, setPopUp] = useState<null | JSX.Element>(null);
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [onlineOrder, setOnlineOrder] = useState(false)
  const [hideClose, setHideClose] = useState(false);

  const value = useMemo(
    () => ({ visible, setVisible, setPopUp, setPopUpTitle, onlineOrder, setOnlineOrder, hideClose, setHideClose }),
    []
  );

  function hidePopUp() {
    setVisible(false);
    setOnlineOrder(false);
  }

  return (
    <PopUpContext.Provider value={value}>
      {children}
      {visible && (
        <CustomPopUp hidePopUp={hidePopUp} popUpTitle={popUpTitle} onlineOrder={onlineOrder} hideClose={hideClose} >
          {popUp}
        </CustomPopUp>
      )}
    </PopUpContext.Provider>
  );
}

export default PopUpContextProvider;
